// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"a00a349b","413":"d9fc740e","988":"547b6aff"}[chunkId] + ".chunk.js";
};